/* RestoreEarth theme — vanilla JS, no dependencies.
   Everything degrades gracefully: with JS off the store still works. */
(function () {
  'use strict';

  var money = function (cents, format) {
    var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, n);
  };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3200);
  }

  /* ---------- Focus trap for drawers/modals ---------- */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
  function trap(container, e) {
    var items = $$(FOCUSABLE, container).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  var openLayer = null, lastFocus = null;
  function openDrawer(el) {
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    openLayer = el;
    var f = $(FOCUSABLE, el); if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeDrawer(el) {
    el = el || openLayer; if (!el) return;
    el.classList.remove('is-open', 'is-visible');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
    openLayer = null;
  }
  document.addEventListener('keydown', function (e) {
    if (!openLayer) return;
    if (e.key === 'Escape') closeDrawer();
    if (e.key === 'Tab') trap(openLayer, e);
  });
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); var t = document.getElementById(o.getAttribute('data-drawer-open')); if (t) openDrawer(t); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__overlay') || e.target.classList.contains('modal__overlay')) {
      var layer = e.target.closest('.drawer, .modal'); if (layer) { e.preventDefault(); closeDrawer(layer); }
    }
    var m = e.target.closest('[data-modal-open]');
    if (m) { e.preventDefault(); var mt = document.getElementById(m.getAttribute('data-modal-open')); if (mt) { mt.classList.add('is-open'); lastFocus = document.activeElement; openLayer = mt; document.body.style.overflow = 'hidden'; var mf = $(FOCUSABLE, mt); if (mf) mf.focus(); } }
  });

  /* ---------- Cart ---------- */
  function cartCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n < 1;
    });
  }
  function refreshCartDrawer() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?section_id=cart-drawer' : '/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-cart-drawer-content]', doc);
        var current = $('[data-cart-drawer-content]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }
  /* The cart drawer is rendered into every page by the layout, so testing for
     it first meant that on /cart we refreshed the hidden drawer and left the
     visible page untouched — Remove looked like it did nothing. Refresh
     whichever surfaces are actually present, page first. */
  function refreshCartPage() {
    var host = $('[data-cart-page]');
    if (!host) return Promise.resolve(false);
    var id = host.getAttribute('data-section-id');
    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id), { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-cart-page]', doc);
        if (!fresh) { window.location.reload(); return true; }
        host.innerHTML = fresh.innerHTML;
        return true;
      })
      .catch(function () { window.location.reload(); return true; });
  }
  var cartBusy = false;
  function updateCart(payload) {
    if (cartBusy) return Promise.resolve();
    cartBusy = true;
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, cart: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.cart.description || res.cart.message || 'Could not update the cart.'); return res.cart; }
        var cart = res.cart;
        cartCount(cart.item_count);
        return refreshCartPage().then(function (onPage) {
          if ($('#cart-drawer')) { return refreshCartDrawer().then(function () { return cart; }); }
          if (!onPage) window.location.reload();
          return cart;
        });
      })
      .catch(function () { toast('Something went wrong. Please try again.'); })
      .then(function (cart) { cartBusy = false; return cart; });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); updateCart({ id: rm.getAttribute('data-cart-remove'), quantity: 0 }); return; }
    var q = e.target.closest('[data-qty]');
    if (q) {
      e.preventDefault();
      var input = $('input', q.closest('.qty'));
      var next = Math.max(0, parseInt(input.value, 10) + parseInt(q.getAttribute('data-qty'), 10));
      input.value = next;
      var key = input.getAttribute('data-line-key');
      if (key) updateCart({ id: key, quantity: next });
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('input[data-line-key]');
    if (input) updateCart({ id: input.getAttribute('data-line-key'), quantity: Math.max(0, parseInt(input.value, 10) || 0) });
  });

  /* ---------- Add to cart (AJAX) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = $('[data-atc]', form);
    var label = btn ? btn.textContent : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = label; }
        if (!res.ok) { toast(res.d.description || res.d.message || 'Could not add to cart.'); return; }
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          cartCount(cart.item_count);
          var drawer = document.getElementById('cart-drawer');
          if (drawer) { refreshCartDrawer().then(function () { openDrawer(drawer); }); }
          else { toast('Added to cart'); }
        });
      })
      .catch(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = label; }
        toast('Something went wrong. Please try again.');
      });
  });

  /* ---------- Variant picker ---------- */
  $$('[data-variant-picker]').forEach(function (root) {
    var dataEl = $('[data-variant-json]', root);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var idInput = $('[data-variant-id]', root);
    var priceEl = $('[data-price]', root);
    var compareEl = $('[data-compare]', root);
    var saveEl = $('[data-save]', root);
    var atc = $('[data-atc]', root);
    var fmt = root.getAttribute('data-money-format') || '${{amount}}';

    function selected() {
      return $$('[data-option-index]', root).map(function (group) {
        var checked = $('input:checked', group);
        return checked ? checked.value : null;
      });
    }
    function update() {
      var opts = selected();
      var match = variants.filter(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      })[0];

      // grey out combinations that don't exist
      $$('[data-option-index]', root).forEach(function (group, gi) {
        $$('input', group).forEach(function (input) {
          var test = selected(); test[gi] = input.value;
          var exists = variants.some(function (v) {
            return test.every(function (o, i) { return o === null || v.options[i] === o; }) && v.available;
          });
          input.disabled = !exists;
        });
      });

      if (!match) {
        if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price, fmt);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = money(match.compare_at_price, fmt); compareEl.hidden = false;
          if (saveEl) { saveEl.textContent = 'Save ' + money(match.compare_at_price - match.price, fmt); saveEl.hidden = false; }
        } else { compareEl.hidden = true; if (saveEl) saveEl.hidden = true; }
      }
      if (atc) {
        atc.disabled = !match.available;
        atc.textContent = match.available ? (atc.getAttribute('data-label') || 'Add to cart') : 'Sold out';
      }
      $$('[data-sticky-price]').forEach(function (el) { el.textContent = money(match.price, fmt); });
      if (history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', match.id);
        history.replaceState({}, '', u.toString());
      }
    }
    root.addEventListener('change', function (e) { if (e.target.matches('input[type=radio]')) update(); });
    update();
  });

  /* ---------- Gallery ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var main = $('[data-gallery-main] img', g);
    $$('[data-gallery-thumb]', g).forEach(function (t) {
      t.addEventListener('click', function () {
        if (!main) return;
        main.src = t.getAttribute('data-src');
        main.srcset = t.getAttribute('data-srcset') || '';
        main.alt = t.getAttribute('data-alt') || '';
        $$('[data-gallery-thumb]', g).forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  });

  /* ---------- Sticky add-to-cart on PDP ---------- */
  var sticky = $('[data-sticky-atc]');
  var anchor = $('[data-atc-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
    }, { rootMargin: '0px 0px -100% 0px' }).observe(anchor);
    $('[data-sticky-buy]', sticky) && $('[data-sticky-buy]', sticky).addEventListener('click', function () {
      var f = $('form[data-product-form]');
      if (f) f.requestSubmit ? f.requestSubmit() : f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  /* ---------- Bundle selector → add the whole kit to the cart ----------
     A kit is several line items, so the CTA posts items[] to /cart/add rather
     than linking to one product page. The hidden inputs are rendered server
     side for the pre-selected kit, so the form still works with JS off; this
     only keeps them in sync as the shopper changes their mind. */
  $$('[data-bundle-root]').forEach(function (root) {
    var form = $('[data-bundle-form]', root);
    var group = $('[data-bundle-group]', root);
    if (!form || !group) return;
    var box = $('[data-bundle-lines]', form);
    var cta = $('[data-bundle-cta]', form);

    function selected() { return $('input[type="radio"]:checked', group) || $('input[type="radio"]', group); }
    function linesOf(r) {
      return (r && r.getAttribute('data-lines') || '').split(',').filter(Boolean).map(function (pair) {
        var bits = pair.split(':');
        return { id: bits[0], quantity: parseInt(bits[1], 10) || 1 };
      });
    }
    function hidden(name, value) {
      var el = document.createElement('input');
      el.type = 'hidden'; el.name = name; el.value = value;
      return el;
    }
    function sync() {
      var r = selected();
      if (!r) return;
      var items = linesOf(r);
      box.innerHTML = '';
      items.forEach(function (it, i) {
        box.appendChild(hidden('items[' + i + '][id]', it.id));
        box.appendChild(hidden('items[' + i + '][quantity]', it.quantity));
      });
      var label = r.getAttribute('data-cta-label');
      if (label) cta.textContent = label;
      cta.setAttribute('data-fallback-url', r.getAttribute('data-url') || '');
      if (r.getAttribute('data-sold-out') === 'true') {
        cta.setAttribute('aria-disabled', 'true');
      } else {
        cta.removeAttribute('aria-disabled');
      }
    }
    group.addEventListener('change', sync);
    sync();

    form.addEventListener('submit', function (e) {
      var r = selected();
      var items = linesOf(r);

      /* Nothing wired up yet in the theme editor — behave like the old link so
         the button is never a dead end. */
      if (!items.length) {
        e.preventDefault();
        var url = cta.getAttribute('data-fallback-url');
        window.location.href = url || (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'collections/all' : '/collections/all');
        return;
      }
      if (cta.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }

      e.preventDefault();
      var label = cta.textContent;
      cta.setAttribute('aria-disabled', 'true');
      cta.textContent = 'Adding…';
      var done = function () { cta.removeAttribute('aria-disabled'); cta.textContent = label; };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) { done(); toast(res.d.description || res.d.message || 'Could not add this kit to the cart.'); return; }
          var after = form.getAttribute('data-after');
          var drawer = document.getElementById('cart-drawer');
          if (after === 'drawer' && drawer) {
            return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              done();
              cartCount(cart.item_count);
              refreshCartDrawer().then(function () { openDrawer(drawer); });
            });
          }
          var ret = $('input[name="return_to"]', form);
          window.location.href = ret ? ret.value : '/checkout';
        })
        .catch(function () {
          /* Network or parsing failure — let the browser post the form the
             plain way rather than stranding the shopper. */
          done();
          HTMLFormElement.prototype.submit.call(form);
        });
    });
  });

  /* ---------- Sale window countdown ----------
     Counts to the single date the merchant set. When it passes, the banner
     removes itself rather than looping — the deadline is real or it is not
     there at all. */
  $$('[data-salebar]').forEach(function (bar) {
    var ends = Date.parse(bar.getAttribute('data-ends'));
    if (isNaN(ends)) { bar.hidden = true; return; }
    var d = $('[data-d]', bar), h = $('[data-h]', bar),
        m = $('[data-m]', bar), sec = $('[data-s]', bar);
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    var t = null;
    var tick = function () {
      var left = ends - Date.now();
      if (left <= 0) { bar.hidden = true; if (t) clearInterval(t); return; }
      if (!d) return;
      var s2 = Math.floor(left / 1000);
      d.textContent = Math.floor(s2 / 86400);
      h.textContent = pad(Math.floor(s2 % 86400 / 3600));
      m.textContent = pad(Math.floor(s2 % 3600 / 60));
      sec.textContent = pad(s2 % 60);
    };
    tick();
    t = setInterval(tick, 1000);
  });

  /* ---------- Announcement bar ----------
     Three messages will not fit across a phone, and hiding the extras meant
     nobody on mobile ever saw two of them. Rotate instead: every message gets
     its turn, and all three stay in the accessibility tree the whole time
     (opacity, not visibility, so a screen reader still reads them all). */
  (function () {
    var bar = $('.announcement');
    if (!bar) return;
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var mq = window.matchMedia('(max-width: 699px)');
    var timer = null, idx = 0;

    function show(n) {
      items.forEach(function (el, i) { el.classList.toggle('is-current', i === n); });
    }
    function start() {
      if (timer) return;
      bar.classList.add('announcement--rotate');
      idx = 0; show(0);
      timer = setInterval(function () {
        idx = (idx + 1) % items.length;
        show(idx);
      }, 4200);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
      bar.classList.remove('announcement--rotate');
      items.forEach(function (el) { el.classList.remove('is-current'); });
    }
    function sync() { mq.matches ? start() : stop(); }

    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else if (mq.addListener) mq.addListener(sync);
    // Don't burn cycles rotating a bar nobody is looking at.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { if (timer) { clearInterval(timer); timer = null; } }
      else sync();
    });
  })();

  /* ---------- Header shadow on scroll ---------- */
  var header = $('.header');
  if (header) {
    var onScroll = function () { header.style.boxShadow = window.scrollY > 8 ? '0 1px 12px rgba(35,31,32,.07)' : 'none'; };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Mouse users don't need focus rings; keyboard users do ---------- */
  document.body.classList.add('no-focus-outline');
  window.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') document.body.classList.remove('no-focus-outline');
  }, { once: true });


  /* ================= MOTION =================
     The .js-anim gate is set inline in the <head> (see layout/theme.liquid)
     so the hidden-before-reveal state exists before first paint and there is
     no flash. If that inline script never ran — JS disabled, or the user
     prefers reduced motion — nothing below hides anything. */
  var animOn = document.documentElement.classList.contains('js-anim');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll() {
    $$('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
    $$('.cdemo__trace[data-draw], .cdemo__reveal').forEach(function (el) { el.classList.add('is-drawn'); });
  }

  if (!animOn || reduce || !('IntersectionObserver' in window)) {
    // Show everything, immediately and permanently.
    revealAll();
  } else {
    // Stagger index: children of a [data-reveal-group] animate in sequence.
    $$('[data-reveal-group]').forEach(function (group) {
      $$('[data-reveal]', group).forEach(function (el, i) {
        if (el.style.getPropertyValue('--d') === '') el.style.setProperty('--d', Math.min(i, 6));
      });
    });

    /* Reveal sweep.
       Deliberately NOT IntersectionObserver-only. IO fires on threshold
       crossings, so an element you jump straight past — anchor link,
       Ctrl+End, a restored scroll position — goes from below-viewport to
       above-viewport without ever crossing one, and never fires. That left
       11 elements permanently invisible in testing. A rAF-throttled sweep
       has no such hole: anything at or above the fold line is revealed,
       whether the user eased past it or teleported. */
    var pending = $$('[data-reveal]');
    var ticking = false;
    var firstSweep = true;

    function sweep() {
      ticking = false;
      var doc = document.documentElement;
      var vh = window.innerHeight || doc.clientHeight;
      // On a page too short to scroll, nothing below the fold line would ever
      // get a scroll event to reveal it. Reveal the lot.
      var scrollable = Math.max(document.body.scrollHeight, doc.scrollHeight) > vh + 4;
      // First sweep reveals everything already on screen, so the viewer never
      // sees a blank band at rest. Later sweeps trigger slightly late (92% of
      // the viewport) so the rise is visible as the element scrolls in.
      var line = !scrollable ? Infinity : (firstSweep ? vh : vh * 0.92);
      firstSweep = false;
      var still = [];
      for (var i = 0; i < pending.length; i++) {
        var el = pending[i];
        var r = el.getBoundingClientRect();
        // top above the fold line, OR any part already scrolled past
        if (r.top < line || r.bottom < 0) el.classList.add('is-in');
        else still.push(el);
      }
      pending = still;
      if (!pending.length) {
        window.removeEventListener('scroll', onScrollSweep);
        window.removeEventListener('resize', onScrollSweep);
      }
    }
    function onScrollSweep() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(sweep);
    }

    /* iOS throttles requestAnimationFrame during momentum scrolling, so a
       sweep-only implementation can sit idle through a whole flick and then
       dump everything in at once — which reads as "the animation is broken"
       on a phone. IntersectionObserver is not subject to that throttle, so it
       drives the common case and the sweep stays on as the safety net that
       catches anything jumped straight past. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var hit = false;
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('is-in');
          io.unobserve(en.target);
          hit = true;
        });
        if (hit) {
          pending = pending.filter(function (el) { return !el.classList.contains('is-in'); });
        }
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      pending.forEach(function (el) { io.observe(el); });
    }

    window.addEventListener('scroll', onScrollSweep, { passive: true });
    window.addEventListener('resize', onScrollSweep, { passive: true });
    // A flick can end without a final scroll event landing; settle after it.
    window.addEventListener('touchend', function () { setTimeout(onScrollSweep, 120); }, { passive: true });
    sweep();
    // Images and fonts settle after first paint and move things around.
    window.addEventListener('load', function () { setTimeout(sweep, 60); });

    /* ---- Conductivity demo: draw the traces when the figure is seen ---- */
    $$('[data-cdemo]').forEach(function (fig) {
      var traces = $$('.cdemo__trace[data-draw]', fig);
      var extras = $$('.cdemo__reveal', fig);

      function measure() {
        traces.forEach(function (t) {
          var len = t.getTotalLength ? t.getTotalLength() : 1200;
          t.style.setProperty('--len', Math.ceil(len));
        });
      }
      function play() {
        measure();
        traces.concat(extras).forEach(function (el) { el.classList.remove('is-drawn'); });
        // force reflow so the reset is committed before the transition restarts
        void fig.offsetWidth;
        requestAnimationFrame(function () {
          traces.concat(extras).forEach(function (el) { el.classList.add('is-drawn'); });
        });
      }
      measure();

      var seen = false;
      var figIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting || seen) return;
          seen = true; play(); figIo.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0 });
      figIo.observe(fig);

      var replay = $('[data-cdemo-replay]', fig);
      if (replay) replay.addEventListener('click', play);

      // Path length changes with the viewport; re-measure on resize.
      var rt;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(function () { if (seen) { measure(); } }, 200);
      }, { passive: true });
    });
  }

  window.themeToast = toast;
})();
